module.exports = __webpack_public_path__ + "pattern6.88ab8ad95a8055d0f3dc.png";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/src/assets/images/pattern6.png
// module id = ../../../../../src/assets/images/pattern6.png
// module chunks = styles